/**
 * Vertical step indicator inside the desktop brand pane. Status only — forward
 * nav is gated by the wizard's Verder button; a *done* row is clickable to jump
 * back (Decision C). Colours are white-on-accent overlays, not shared tokens,
 * because the rail lives on the blue gradient surface.
 */

function CheckGlyph() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12l5 5L20 6" />
    </svg>
  );
}

export function StepRail({
  step,
  labels,
  onJump,
}: {
  step: number;
  labels: string[];
  onJump: (i: number) => void;
}) {
  return (
    <ol className="relative z-[1] mt-9 flex flex-col gap-0.5">
      {labels.map((label, i) => {
        const state = i === step ? "active" : i < step ? "done" : "upcoming";
        const done = state === "done";
        const dotStyle =
          state === "active"
            ? { borderColor: "#fff", background: "#fff", color: "var(--accent)" }
            : done
              ? { borderColor: "var(--warm)", background: "var(--warm)", color: "#fff" }
              : { borderColor: "rgba(255,255,255,.35)", color: "rgba(255,255,255,.55)" };
        const textColor =
          state === "active" ? "#fff" : done ? "rgba(255,255,255,.85)" : "rgba(255,255,255,.55)";
        const content = (
          <>
            <span
              className="grid h-[26px] w-[26px] flex-none place-items-center rounded-full border-2 font-mono-badge text-xs"
              style={dotStyle}
            >
              {done ? <CheckGlyph /> : i + 1}
            </span>
            <span className="text-sm font-medium" style={{ color: textColor }}>
              {label}
            </span>
          </>
        );
        if (done) {
          return (
            <li key={label}>
              <button
                type="button"
                onClick={() => onJump(i)}
                className="flex w-full items-center gap-3 rounded-[var(--radius)] py-2.5 text-left transition-colors hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2"
              >
                {content}
              </button>
            </li>
          );
        }
        return (
          <li key={label} className="flex items-center gap-3 py-2.5" aria-current={state === "active" ? "step" : undefined}>
            {content}
          </li>
        );
      })}
    </ol>
  );
}
